import MatchCenterPage from '../components/MatchCenter/MatchCenterPage';

export default MatchCenterPage;
